/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
/**
 * Specifies an observer callback that is run when the decorated property
 * changes. The observer receives the current and old value as arguments.
 */
export const observer =
  (observer) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (proto, propName) => {
    // if we haven't wrapped `updated` in this class, do so
    if (!proto.constructor._observers) {
      proto.constructor._observers = new Map();
      const userUpdated = proto.updated;
      proto.updated = function (changedProperties) {
        userUpdated.call(this, changedProperties);
        changedProperties.forEach((v, k) => {
          const observers = this.constructor._observers;
          const observer = observers.get(k);
          if (observer !== undefined) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            observer.call(this, this[k], v);
          }
        });
      };
      // clone any existing observers (superclasses)
      // eslint-disable-next-line no-prototype-builtins
    } else if (!proto.constructor.hasOwnProperty('_observers')) {
      const observers = proto.constructor._observers;
      proto.constructor._observers = new Map();
      observers.forEach(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (v, k) => proto.constructor._observers.set(k, v)
      );
    }
    // set this method
    proto.constructor._observers.set(propName, observer);
  };
//# sourceMappingURL=observer.js.map
